import { Alert } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import CustomCollapse from 'components/CustomCollapse';

import FinancingDetails from '../FinancingDetails';

const EstimatedMonthlyPayment = ({
  calculatedData,
  reviewFlag,
  completedSteps,
  viewAppFlow,
  unfilled,
  approvedApplication,
}) => {
  const [showAlert, setShowAlert] = useState(false);
  const monthlyPayData = {
    ...calculatedData?.calculatedData,
    apr: calculatedData?.formData?.rate,
    baloonPayment: calculatedData?.formData?.balloonPay,
  };

  useEffect(() => {
    if (Object.entries(calculatedData).length > 0)
      setShowAlert(!approvedApplication ? true : false);
  }, []);
  return (
    <>
      {showAlert && (
        <Alert
          severity="warning"
          onClose={() => setShowAlert(false)}
          sx={{
            background: 'rgba(239, 171, 57, 0.05)',
            borderWidth: '1px 1px 1px 5px',
            borderStyle: 'solid',
            borderColor: 'rgba(239, 171, 57, 0.5)',
          }}
        >
          Please click the payment calculator and enter vehicle payment information. Review the auto
          populated results in the financing terms and proceed. Iterate the value if required by
          taking the payment calculator action again.
        </Alert>
      )}

      <CustomCollapse
        heading={approvedApplication ? 'Approved Financing Terms' : 'Estimated monthly payment'}
        payCalcButton={!approvedApplication}
        monthlyPayData={calculatedData}
        open={approvedApplication ? false : true}
        reviewFlag={reviewFlag}
        completedSteps={completedSteps}
        viewAppFlow={viewAppFlow}
        unfilled={unfilled}
      >
        <FinancingDetails monthlyPayData={monthlyPayData} calculatedData={calculatedData} />
      </CustomCollapse>
    </>
  );
};
export default EstimatedMonthlyPayment;

EstimatedMonthlyPayment.propTypes = {
  calculatedData: PropTypes.instanceOf(Object),
  reviewFlag: PropTypes.bool,
  completedSteps: PropTypes.array,
  viewAppFlow: PropTypes.bool,
  unfilled: PropTypes.bool,
  approvedApplication: PropTypes.bool,
};
EstimatedMonthlyPayment.defaultProps = {
  calculatedData: {},
  reviewFlag: false,
  completedSteps: [],
  viewAppFlow: false,
  unfilled: false,
  approvedApplication: false,
};
